export default {
  pdf: {
    name: 'PDF',
    extensions: ['pdf']
  },
  document: {
    name: 'Document',
    extensions: ['doc', 'docx', 'html', 'html', 'odt', 'xls', 'xlsx', 'ods', 'ppt', 'pptx', 'txt']
  },
  image: {
    name: 'Image',
    extensions: ['jpeg', 'jpg', 'tif', 'tiff', 'gif', 'bmp', 'png', 'pmg', 'heif', 'heic']
  },
  media: {
    name: 'Audio/Video',
    extensions: ['aac', 'flac', 'mp3', 'wav', 'mkv', 'flv', 'avi', 'mov', 'wmv', 'mp4']
  },
  archive: {
    name: 'Archive',
    extensions: ['iso', '7z', 's7z', 'arc', 'dmg', 'rar', 'zip']
  }
}



// WEBPACK FOOTER //
// ./src/constants/filetypes.js